const scenario_oubo = [
  { //1
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"fcea5498-8cd6-4a3a-9c58-c73308975d21",
    "beforenodeX":148,
    "beforenodeY":84,
    "start_flg":true,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":2
    },
    "parameter":[],
    "mainmessage":"$1\u3078\u3054\u8a2a\u554f\u9802\u304d\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\n\u3053\u3061\u3089\u304b\u3089\u5fdc\u52df\u3092\u53d7\u3051\u4ed8\u3051\u3066\u304a\u308a\u307e\u3059\u3002",
    "status":2,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"dbbf627a-43a1-45c5-973b-6e120614d896",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30143
  },
  {//2
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"dbbf627a-43a1-45c5-973b-6e120614d896",
    "beforenodeX":150,
    "beforenodeY":224,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"$Q1[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"df40b2cb-e719-4998-bd2e-6b1157f8e00d",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30144
  },
  {//3
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"df40b2cb-e719-4998-bd2e-6b1157f8e00d",
    "beforenodeX":510,
    "beforenodeY":225,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"",
      "custom_tag":"",
      "apply_flg":false,
      "any_flg":false
    },
    "mainmessage":"$Q2[input][/input]",
    "status":6,
    "select":[
      {
        "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
        "input_type":"free",
        "custom_tag":"",
        "custom":"",
        "default_birth":"",
        "date_type":"",
        "apply_flg":false,
        "any_flg":false,
        "default_flg":false,
        "keep_time_hour":0,
        "keep_time_minute":0
        }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30145
  },
  {//4
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"39b40802-e64d-4a14-9b56-d5aaccd13904",
    "beforenodeX":882,
    "beforenodeY":224,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"$Q3[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"3d6f5063-afdc-4c5b-9489-59c570fdc1a1",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30146
  },
  {//5
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"3d6f5063-afdc-4c5b-9489-59c570fdc1a1",
    "beforenodeX":1237,
    "beforenodeY":226,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"$Q4[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"bc45ae1d-a25b-4434-b522-bda4e8859031",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30147
  },
  {//6
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"bc45ae1d-a25b-4434-b522-bda4e8859031",
    "beforenodeX":1598,
    "beforenodeY":227,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"$Q5[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"78ee8b84-f4b7-487e-806f-71be6b4bfe9a",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30148
  },
  {//7
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"78ee8b84-f4b7-487e-806f-71be6b4bfe9a",
    "beforenodeX":149,
    "beforenodeY":355,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":1
    },
    "parameter":[],
    "mainmessage":"[cv][/cv]",
    "status":1,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"f0eef0fd-ad16-421a-ae00-fcc68ed53a4b",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30149
  },
  {
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"3f6794c2-7356-4676-9550-366b47bc6b14",
    "beforenodeX":152,
    "beforenodeY":562,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":0
    },
    "parameter":[],
    "mainmessage":"\u3054\u5165\u529b\u3044\u305f\u3060\u304d\u307e\u3057\u3066\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3057\u305f\u3002\n\u3054\u5165\u529b\u3044\u305f\u3060\u304d\u307e\u3057\u305f\u60c5\u5831\u3092\u62c5\u5f53\u8005\u3078\u304a\u9001\u308a\u3044\u305f\u3057\u307e\u3059\u306e\u3067\n\u4eca\u3057\u3070\u3089\u304f\u304a\u5f85\u3061\u304f\u3060\u3055\u3044\u3002",
    "status":0,
    "select":[
      {
        "msg_type":"button",
        "message":"\u6700\u521d\u3078\u623b\u308b",
        "text_option":"white",
        "next_node":"c7c1b652-26e8-4a20-b81e-2de83220bb2c",
        "point":"0"
      }
    ],
    "template":"[button]\u6700\u521d\u3078\u623b\u308b,white[/button]",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30151
  },
  {
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"c7c1b652-26e8-4a20-b81e-2de83220bb2c",
    "beforenodeX":510,
    "beforenodeY":626,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":9
    },
    "parameter":[],
    "mainmessage":"[restart][/restart]",
    "status":9,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30152
  },
  {
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"f0eef0fd-ad16-421a-ae00-fcc68ed53a4b",
    "beforenodeX":150,
    "beforenodeY":460,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":10
    },
    "parameter":{
      "title":"\u5fdc\u52df\u304c\u3054\u3056\u3044\u307e\u3057\u305f\u3002",
      "to":"",
      "cc":"",
      "after":0
    },
    "mainmessage":"<p>\u3054\u62c5\u5f53\u8005\u69d8</p><p><br></p><p>\u304a\u4e16\u8a71\u306b\u306a\u3063\u3066\u304a\u308a\u307e\u3059\u3002</p><p>\u30db\u30fc\u30e0\u30da\u30fc\u30b8\u3088\u308a\u5fdc\u52df\u304c\u3054\u3056\u3044\u307e\u3057\u305f\u306e\u3067</p><p>\u3054\u78ba\u8a8d\u306e\u307b\u3069\u3088\u308d\u3057\u304f\u304a\u9858\u3044\u3044\u305f\u3057\u307e\u3059\u3002</p><p><br></p><p>---</p><p><br></p><p>\u304a\u540d\u524d\uff1a__30149.name__</p><p>Email\uff1a__30149.email__</p><p>TEL\uff1a__30149.tel__</p>",
    "status":10,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"3f6794c2-7356-4676-9550-366b47bc6b14",
        "point":""
      }
    ],
    "template":"",
    "is_cv":true,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30153
  }
]

export {
  scenario_oubo
}


// WEBPACK FOOTER //
// ./src/assets/data/tutorial_scenario_oubo.js